import Vue from 'vue';
import App from './App';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'  //引入element-ui库
import 'element-ui/lib/theme-chalk/index.css'  //引入element-ui样式
Vue.use(ElementUI)  //全局注册element-ui

import 'element-ui/lib/theme-chalk/index.css'
import { store } from './store/store'
import './styles/module-reset.less' //
import '../static/bootstrap/css/bootstrap.min.css';
import '../static/bootstrap/js/bootstrap.min';
import '../static/bootstrap-datepicker.js';
import '../static/reset.css';
import router from './router';
import * as echarts from 'echarts';
import 'echarts-gl';
import 'echarts-liquidfill' //在这里引入
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false
import Axios from './providers/http-service.js';
Vue.prototype.$axios = Axios;
Vue.prototype.HOST = '/api';

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})
window._AMapSecurityConfig = {
  securityJsCode: "591905303edae4ff5674f0542a9970dc" //配合key值的密钥
};
new Vue({
  store: store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js